<div class="loading-overlay__wrapper" id="loading-overlay-search">
  <div class="loading-overlay__icons">
    <div class="items">
      @for (icon of iconArray; track icon) {
        <svg-icon
          src="/images/search/{{ icon }}.svg"
        ></svg-icon>
      }
    </div>
  </div>
  <div
    class="loading-overlay__text"
    i18n="Search in entire catalog@@products.extended.loading.text"
    >
    We are currently searching our full catalog for you
  </div>
  <p class="loading-overlay__dots"></p>
</div>
